import React from 'react';
import {
  loaderAnimation,
  loaderAnimationMedium,
  loaderAnimationLarge,
  loaderAnimationWhite,
  loaderAnimationMediumWhite,
  loaderAnimationLargeWhite
} from './loadingIcon.module.scss';

const LoaderStyle = {
  Blue: 'blue',
  White: 'white'
};

const Size = {
  small: 'small',
  medium: 'medium',
  large: 'large'
};
const LoadingIcon = props => {
  const { style, size } = props;
  return (
    <>
      {style === LoaderStyle.Blue && size === Size.small && (
        <div className={loaderAnimation} />
      )}
      {style === LoaderStyle.Blue && size === Size.medium && (
        <div className={loaderAnimationMedium} />
      )}
      {style === LoaderStyle.Blue && size === Size.large && (
        <div className={loaderAnimationLarge} />
      )}
      {style === LoaderStyle.White && size === Size.small && (
        <div className={loaderAnimationWhite} />
      )}
      {style === LoaderStyle.White && size === Size.medium && (
        <div className={loaderAnimationMediumWhite} />
      )}
      {style === LoaderStyle.White && size === Size.large && (
        <div className={loaderAnimationLargeWhite} />
      )}
    </>
  );
};
export { LoadingIcon };
